import React from 'react';
import { useTheme } from '@mui/material';

export const FAQ = (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryColor },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} fill="none" {...props}>
            <path
                fill={primaryColor}
                d="M43.689 10.786c3.31 0 6 2.69 6 6v15h-3v-15c0-1.66-1.34-3-3-3h-30c-1.66 0-3 1.34-3 3v30c0 1.66 1.34 3 3 3h23v3h-23c-3.31 0-6-2.69-6-6v-30c0-3.31 2.69-6 6-6h30Zm-15 27.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5Zm2.25-18.75c3.328 0 6 2.719 6 6.028a6.026 6.026 0 0 1-3.272 5.362L30.19 32.94v1.847c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5V32.02c0-.562.319-1.078.815-1.34l4.294-2.194a3.02 3.02 0 0 0 1.641-2.69c0-1.67-1.35-3.029-3-3.029h-5.354a2.248 2.248 0 0 0-2.174 1.678l-.019.065a1.495 1.495 0 0 1-1.828 1.07c-.797-.216-1.284-1.032-1.068-1.828l.018-.066-.01.019a5.257 5.257 0 0 1 5.081-3.92h5.354Z"
            />
            <path
                fill={primaryColor}
                d="M47.04 52.824c.246.247.596.39.957.39s.706-.138.957-.39l7-6.982a1.18 1.18 0 0 0-.054-1.74 1.374 1.374 0 0 0-1.854.05l-4.736 4.724V38.018c0-.683-.585-1.232-1.313-1.232-.727 0-1.312.549-1.312 1.232v10.858l-4.73-4.718a1.368 1.368 0 0 0-1.855-.051 1.18 1.18 0 0 0-.054 1.74l7 6.982-.006-.005Z"
            />
        </svg>
    );
};

export default FAQ;
